/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Health } from '../models/Health';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HealthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Health check
     * Health check endpoint
     * @returns Health
     * @throws ApiError
     */
    public getHealth(): CancelablePromise<Health> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/health',
        });
    }
}
